// @ts-ignore
// @ts-nocheck
import { createApp } from 'vue'
import App from './App.vue'

// Add public path
import './public-path.js'

// Add extension
import './commons/prototype'

// Globally Registered Components
import { useComponents } from '@/commons/globalComponents.js'

// phím tắt
import { shortKey } from '@/commons/directives/shortkey.js'

// Globally Registered Components
import { pluginInstall } from '@/commons/globalPlugin.js'

// Đăng ký popup
import { register } from '@/commons/globalPopup'

// filter
import { initFilter } from './commons/msFormat'

// Styles: SCSS
import '@/assets/css/flexbox.css'
import '@/assets/css/common.css'
import '@/assets/scss/scroller.scss'
import '@/assets/scss/override.scss'
import '@/assets/scss/icons.scss'
import '@/assets/scss/btn.scss'
import '@/assets/scss/form.scss'
import '@/assets/scss/app.scss'
import '@/assets/scss/main-style.scss'
// Khai báo router
import router from '@/routers/router'

// Khai báo store
import store from '@/stores/store'

// Sử dụng localize
import i18n from '@/i18ns/i18n'

import { PromiseDialog } from 'vue3-promise-dialog'
const app = createApp(App)
useComponents(app)
app.directive('shortkey', shortKey)
pluginInstall(app)
register(app)
initFilter(app)

app.config.productionTip = false
app.use(router)
app.use(store)
app.use(i18n)
app.use(PromiseDialog)

/**
 * directive xử lý style.visibility
 */
app.directive('visible', function (el, binding) {
  el.style.visibility = binding.value ? 'visible' : 'hidden'
})

app.mount('#app')

if (process.env.NODE_ENV === 'development') {
  app.config.performance = true
}
